import React from 'react'
import Expertise from '/react4xp/components/Expertise'
import { ExpertiseType } from '/react4xp/components/Expertise/type'

interface Props {
   tag?: string
   expertises?: ExpertiseType[],
}

export default function AreasOfExpertise(props: Props) {
   const { tag, expertises } = props

   return (
      <div className="areas-of-expertise">
         <div className="grid-container">
            <div className="grid-row">
               <div className="c-12">
                  {tag && <div className="areas-of-expertise__tag">
                     {tag}
                  </div>}
               </div>
            </div>
         </div>
         {expertises &&
            <div className="areas-of-expertise__accordion-group">
               {expertises.map((expertise, index) => {
                  return <Expertise key={index} {...expertise} />
               })}
            </div>
         }
      </div>
   )
}
